import { render, staticRenderFns } from "./EmptyNumbers.vue?vue&type=template&id=39d47d29&"
import script from "./EmptyNumbers.vue?vue&type=script&lang=js&"
export * from "./EmptyNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports